// extracted by mini-css-extract-plugin
export default {"news":"News_news__R9jC-","header":"News_header__zC7Ot","divider":"News_divider__inEsm"};